import { Chantier, User, Client, Task, Document } from './types'

// Users - France Décoration Team
export const currentUser: User = {
  id: 'u1',
  name: 'Naoufel Grissa',
  email: 'naoufel@francedecoration.fr',
  role: 'admin',
  avatar:
    'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
}

export const direction: User[] = []

export const bureau: User[] = [
  {
    id: 'b1',
    name: 'Randa Grissa',
    email: 'randa@francedecoration.fr',
    role: 'bureau',
    avatar:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  },
  {
    id: 'b2',
    name: 'Dina Antakly',
    email: 'dina@francedecoration.fr',
    role: 'bureau',
    avatar:
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  },
  {
    id: 'b3',
    name: 'Mehdi Fathallah',
    email: 'mehdi@francedecoration.fr',
    role: 'bureau',
    avatar:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  },
]

export const chefsEquipe: User[] = [
  {
    id: 'c1',
    name: 'Mohamad Fakhreddine',
    email: 'mohamad@francedecoration.fr',
    role: 'chef_equipe',
    avatar:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  },
  {
    id: 'c2',
    name: 'Majdi Bougamra',
    email: 'majdi@francedecoration.fr',
    role: 'chef_equipe',
    avatar:
      'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  },
]

export const techniciens: User[] = [
  {
    id: 't1',
    name: 'Karim Benali',
    email: 'karim@francedecoration.fr',
    role: 'technicien',
    avatar:
      'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  },
  {
    id: 't2',
    name: 'Yassine Hamdi',
    email: 'yassine@francedecoration.fr',
    role: 'technicien',
    avatar:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  },
  {
    id: 't3',
    name: 'Omar Mansouri',
    email: 'omar@francedecoration.fr',
    role: 'technicien',
    avatar:
      'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  },
  {
    id: 't4',
    name: 'Sami Khelifi',
    email: 'sami@francedecoration.fr',
    role: 'technicien',
    avatar:
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  },
]

export const allUsers: User[] = [
  currentUser,
  ...direction,
  ...bureau,
  ...chefsEquipe,
  ...techniciens,
]

// Clients
export const clients: Client[] = [
  {
    id: 'cl1',
    raisonSociale: 'Indigo Group',
    contactName: 'Isabelle Mercier',
    phone: '+33 1 45 67 89 01',
    email: 'i.mercier@group-indigo.com',
    billingAddress: '12 Avenue des Champs-Élysées, 75008 Paris',
    sites: [
      'Parking Gare du Nord - Paris',
      'Parking Gare Saint-Jean - Bordeaux',
      'Parking Aéroport Lyon-Saint Exupéry',
      'Parking Centre-Ville - Marseille',
    ],
    isStrategicAccount: true,
    notes:
      'Compte stratégique - Contrat cadre annuel. Contact privilégié pour nouveaux sites.',
  },
  {
    id: 'cl2',
    raisonSociale: 'Carrefour France',
    contactName: 'David Fontaine',
    phone: '+33 1 56 78 90 12',
    email: 'd.fontaine@carrefour.fr',
    billingAddress: '93 Avenue de Paris, 91300 Massy',
    sites: ['Carrefour Massy', 'Carrefour Évry', 'Carrefour Rosny-sous-Bois'],
    isStrategicAccount: true,
    notes: 'Signalétique et marquage sol pour réseau Île-de-France',
  },
  {
    id: 'cl3',
    raisonSociale: 'Leroy Merlin',
    contactName: 'Nathalie Dubois',
    phone: '+33 3 20 12 34 56',
    email: 'n.dubois@leroymerlin.fr',
    billingAddress: 'Rue Chanzy, 59260 Lezennes',
    sites: ['Leroy Merlin Lille', "Leroy Merlin Villeneuve d'Ascq"],
    isStrategicAccount: false,
    notes: 'Aménagement espaces commerciaux et signalétique',
  },
  {
    id: 'cl4',
    raisonSociale: 'Réseau Franchise Optique Vision',
    contactName: 'Éric Blanc',
    phone: '+33 4 78 90 12 34',
    email: 'e.blanc@optiquevision.fr',
    billingAddress: '45 Rue de la République, 69002 Lyon',
    sites: [
      'Optique Vision Lyon Part-Dieu',
      'Optique Vision Lyon Bellecour',
      'Optique Vision Villeurbanne',
    ],
    isStrategicAccount: false,
    notes: 'Franchise - Charte graphique stricte à respecter',
  },
]

// Chantiers
export const chantiers: Chantier[] = [
  {
    id: 'ch1',
    name: 'Parking Indigo Gare du Nord - Rénovation signalétique',
    clientId: 'cl1',
    location: '18 Rue de Dunkerque',
    city: 'Paris',
    country: 'France',
    workType: 'signaletique_interieure',
    description:
      'Rénovation complète de la signalétique intérieure sur 4 niveaux. Pose de panneaux directionnels, marquage au sol, numérotation des places.',
    status: 'en_cours',
    priority: 'normal',
    startDate: '2025-04-01',
    endDate: '2025-04-25',
    chefEquipeId: 'c1',
    team: [techniciens[0], techniciens[1]],
    progress: 65,
    createdAt: '2025-03-15',
    createdBy: 'Randa Grissa',
    tasks: [
      {
        id: 'task1',
        title: 'Installation signalétique niveau -1',
        description:
          'Pose des panneaux directionnels et marquage au sol niveau -1',
        createdBy: 'Karim Benali',
        createdAt: '2025-04-05',
        dueDate: '2025-04-10',
        assignedTo: 't1',
        validationStatus: 'approved',
        validatedBy: 'Mohamad Fakhreddine',
        validatedAt: '2025-04-06',
        validationComment:
          'Excellent travail, conforme au cahier des charges Indigo',
        images: [
          {
            id: 'img1',
            url: 'https://images.unsplash.com/photo-1590674899484-d5640e854abe?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
            uploadedBy: 'Karim Benali',
            uploadedAt: '2025-04-05',
            description: "Vue d'ensemble niveau -1 avant intervention",
            photoType: 'avant',
            taskId: 'task1',
          },
          {
            id: 'img2',
            url: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
            uploadedBy: 'Karim Benali',
            uploadedAt: '2025-04-06',
            description: 'Signalétique installée niveau -1',
            photoType: 'apres',
            taskId: 'task1',
          },
        ],
      },
      {
        id: 'task2',
        title: 'Marquage au sol niveau -2',
        description:
          'Traçage des lignes de circulation et numérotation des places',
        createdBy: 'Yassine Hamdi',
        createdAt: '2025-04-10',
        dueDate: '2025-04-15',
        assignedTo: 't2',
        validationStatus: 'pending',
        images: [
          {
            id: 'img3',
            url: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
            uploadedBy: 'Yassine Hamdi',
            uploadedAt: '2025-04-11',
            description: 'Marquage en cours niveau -2',
            photoType: 'pendant',
            taskId: 'task2',
          },
          {
            id: 'img4',
            url: 'https://images.unsplash.com/photo-1590674899484-d5640e854abe?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
            uploadedBy: 'Yassine Hamdi',
            uploadedAt: '2025-04-12',
            description: 'Marquage terminé niveau -2',
            photoType: 'apres',
            taskId: 'task2',
          },
        ],
      },
    ],
    documents: [
      {
        id: 'doc1',
        name: 'Bon de commande Indigo - Gare du Nord',
        url: '#',
        type: 'bon_commande',
        uploadedBy: 'Randa Grissa',
        uploadedAt: '2025-03-15',
      },
      {
        id: 'doc2',
        name: 'Plan technique parking',
        url: '#',
        type: 'plan',
        uploadedBy: 'Randa Grissa',
        uploadedAt: '2025-03-20',
      },
    ],
  },
  {
    id: 'ch2',
    name: 'Carrefour Massy - Application résine sol',
    clientId: 'cl2',
    location: '93 Avenue de Paris',
    city: 'Massy',
    country: 'France',
    workType: 'revetement',
    description:
      'Application de résine époxy sur 500m² dans la zone fruits et légumes',
    status: 'bloque',
    priority: 'urgent',
    startDate: '2025-04-10',
    endDate: '2025-04-18',
    chefEquipeId: 'c2',
    team: [techniciens[2], techniciens[3]],
    progress: 30,
    createdAt: '2025-03-25',
    createdBy: 'Dina Antakly',
    tasks: [
      {
        id: 'task3',
        title: 'Préparation du sol',
        description:
          'Ponçage et nettoyage de la surface avant application résine',
        createdBy: 'Omar Mansouri',
        createdAt: '2025-04-10',
        dueDate: '2025-04-12',
        assignedTo: 't3',
        validationStatus: 'approved',
        validatedBy: 'Majdi Bougamra',
        validatedAt: '2025-04-11',
        images: [
          {
            id: 'img5',
            url: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
            uploadedBy: 'Omar Mansouri',
            uploadedAt: '2025-04-10',
            description: 'Sol avant préparation',
            photoType: 'avant',
            taskId: 'task3',
          },
        ],
      },
      {
        id: 'task4',
        title: 'BLOCAGE - Livraison résine retardée',
        description:
          'Fournisseur annonce retard de 3 jours sur livraison résine époxy',
        createdBy: 'Majdi Bougamra',
        createdAt: '2025-04-13',
        assignedTo: 'c2',
        validationStatus: 'pending',
        images: [
          {
            id: 'img6',
            url: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
            uploadedBy: 'Majdi Bougamra',
            uploadedAt: '2025-04-13',
            description: 'Bon de livraison fournisseur - retard confirmé',
            photoType: 'probleme',
            taskId: 'task4',
          },
        ],
      },
    ],
    documents: [],
  },
  {
    id: 'ch3',
    name: 'Parking Indigo Bordeaux - Peinture décorative',
    clientId: 'cl1',
    location: 'Rue Charles Domercq',
    city: 'Bordeaux',
    country: 'France',
    workType: 'peinture_decorative',
    description: 'Peinture décorative murale et plafond niveau accueil',
    status: 'termine',
    priority: 'normal',
    startDate: '2025-03-15',
    endDate: '2025-03-30',
    chefEquipeId: 'c1',
    team: [techniciens[0]],
    progress: 100,
    createdAt: '2025-03-01',
    createdBy: 'Randa Grissa',
    tasks: [
      {
        id: 'task5',
        title: 'Peinture murale niveau accueil',
        description: 'Application peinture décorative selon charte Indigo',
        createdBy: 'Karim Benali',
        createdAt: '2025-03-20',
        dueDate: '2025-03-28',
        assignedTo: 't1',
        validationStatus: 'approved',
        validatedBy: 'Mohamad Fakhreddine',
        validatedAt: '2025-03-29',
        validationComment: 'Rendu impeccable, client très satisfait',
        images: [
          {
            id: 'img7',
            url: 'https://images.unsplash.com/photo-1562259949-e8e7689d7828?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
            uploadedBy: 'Karim Benali',
            uploadedAt: '2025-03-20',
            description: 'Mur avant peinture',
            photoType: 'avant',
            taskId: 'task5',
          },
          {
            id: 'img8',
            url: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
            uploadedBy: 'Karim Benali',
            uploadedAt: '2025-03-28',
            description: 'Peinture terminée',
            photoType: 'apres',
            taskId: 'task5',
          },
          {
            id: 'img9',
            url: 'https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
            uploadedBy: 'Karim Benali',
            uploadedAt: '2025-03-29',
            description: 'Validation client sur site',
            photoType: 'reception',
            taskId: 'task5',
          },
        ],
      },
    ],
    documents: [
      {
        id: 'doc3',
        name: 'PV de réception signé',
        url: '#',
        type: 'pv_reception',
        uploadedBy: 'Mohamad Fakhreddine',
        uploadedAt: '2025-03-30',
      },
    ],
  },
  {
    id: 'ch4',
    name: 'Leroy Merlin Lille - Signalétique extérieure',
    clientId: 'cl3',
    location: 'Rue Chanzy',
    city: 'Lezennes',
    country: 'France',
    workType: 'signaletique_exterieure',
    description:
      'Installation enseigne lumineuse et panneaux directionnels parking',
    status: 'a_planifier',
    priority: 'normal',
    startDate: '2025-05-05',
    endDate: '2025-05-12',
    chefEquipeId: 'c2',
    team: [],
    progress: 0,
    createdAt: '2025-04-15',
    createdBy: 'Dina Antakly',
    tasks: [],
    documents: [
      {
        id: 'doc4',
        name: 'Devis Leroy Merlin',
        url: '#',
        type: 'devis',
        uploadedBy: 'Dina Antakly',
        uploadedAt: '2025-04-15',
      },
    ],
  },
  {
    id: 'ch5',
    name: 'Optique Vision Lyon - Aménagement commercial',
    clientId: 'cl4',
    location: '45 Rue de la République',
    city: 'Lyon',
    country: 'France',
    workType: 'amenagement_commercial',
    description:
      'Aménagement complet nouvelle boutique : peinture, mobilier, signalétique',
    status: 'en_attente_client',
    priority: 'normal',
    startDate: '2025-03-20',
    endDate: '2025-04-15',
    chefEquipeId: 'c1',
    team: [techniciens[1], techniciens[2]],
    progress: 95,
    createdAt: '2025-03-10',
    createdBy: 'Randa Grissa',
    tasks: [
      {
        id: 'task6',
        title: 'Aménagement complet boutique',
        description:
          'Peinture, pose mobilier, signalétique selon charte franchise',
        createdBy: 'Yassine Hamdi',
        createdAt: '2025-04-10',
        dueDate: '2025-04-14',
        assignedTo: 't2',
        validationStatus: 'approved',
        validatedBy: 'Mohamad Fakhreddine',
        validatedAt: '2025-04-14',
        validationComment:
          'Travaux terminés, en attente validation client final',
        images: [
          {
            id: 'img10',
            url: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
            uploadedBy: 'Yassine Hamdi',
            uploadedAt: '2025-04-14',
            description: "Boutique aménagée - vue d'ensemble",
            photoType: 'apres',
            taskId: 'task6',
          },
        ],
      },
    ],
    documents: [],
  },
  {
    id: 'ch6',
    name: 'Parking Indigo Lyon Aéroport - Marquage sol',
    clientId: 'cl1',
    location: 'Aéroport Lyon-Saint Exupéry',
    city: 'Colombier-Saugnieu',
    country: 'France',
    workType: 'marquage_sol',
    description: 'Réfection marquage au sol parking P3 - 800 places',
    status: 'facturable',
    priority: 'normal',
    startDate: '2025-03-10',
    endDate: '2025-03-25',
    chefEquipeId: 'c2',
    team: [techniciens[2], techniciens[3]],
    progress: 100,
    createdAt: '2025-02-28',
    createdBy: 'Mehdi Fathallah',
    tasks: [
      {
        id: 'task7',
        title: 'Marquage 800 places parking P3',
        description: 'Traçage lignes et numérotation complète',
        createdBy: 'Omar Mansouri',
        createdAt: '2025-03-20',
        dueDate: '2025-03-24',
        assignedTo: 't3',
        validationStatus: 'approved',
        validatedBy: 'Majdi Bougamra',
        validatedAt: '2025-03-25',
        validationComment: 'PV signé par responsable Indigo, prêt facturation',
        images: [
          {
            id: 'img11',
            url: 'https://images.unsplash.com/photo-1590674899484-d5640e854abe?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
            uploadedBy: 'Omar Mansouri',
            uploadedAt: '2025-03-24',
            description: 'Marquage terminé P3',
            photoType: 'apres',
            taskId: 'task7',
          },
          {
            id: 'img12',
            url: 'https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
            uploadedBy: 'Majdi Bougamra',
            uploadedAt: '2025-03-25',
            description: 'Validation responsable Indigo',
            photoType: 'reception',
            taskId: 'task7',
          },
        ],
      },
    ],
    documents: [
      {
        id: 'doc5',
        name: 'PV réception Indigo Lyon',
        url: '#',
        type: 'pv_reception',
        uploadedBy: 'Majdi Bougamra',
        uploadedAt: '2025-03-25',
      },
    ],
  },
]

export const getClientById = (clientId: string): Client | undefined => {
  return clients.find((c) => c.id === clientId)
}

export const getChantiersByClient = (clientId: string): Chantier[] => {
  return chantiers.filter((ch) => ch.clientId === clientId)
}

export const getChefEquipe = (chefId: string): User | undefined => {
  return allUsers.find((u) => u.id === chefId)
}

export const getPendingValidationsCount = (): number => {
  return chantiers.reduce((count, chantier) => {
    return (
      count +
      chantier.tasks.filter((task) => task.validationStatus === 'pending')
        .length
    )
  }, 0)
}

export const getAllChantierImages = (chantierId: string) => {
  const chantier = chantiers.find((ch) => ch.id === chantierId)
  if (!chantier) return []
  return chantier.tasks.flatMap((task) => task.images)
}
